import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HTTP_CP_Company } from '@api-new/companyservice';
import { ActivityLogClickDirective } from '@client-ui/directives/activity-log-click.directive';
import { Store } from '@ngrx/store';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { addClassAndTargetToInnerHtmlConsentText } from '@shared-lib/utils/add-class-and-target-to-inner-html-consent-text';
import { CpCheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { ANALYTIC_CLICK_EVENT_NAMES } from '@shared/constants/analytic-click-event-names';
import { AuthService } from '@shared/services/auth.service';
import { agreeToTermsAndConditions } from '@shared/store/client-user/client-user.actions';
import { selectCompany } from '@shared/store/company/company.selectors';
import { ButtonDirective } from 'primeng/button';
import { Observable } from 'rxjs';

@Component({
  selector: 'cp-terms-and-conditions-agreement',
  templateUrl: './terms-and-conditions-agreement.component.html',
  styleUrls: ['./terms-and-conditions-agreement.component.scss'],
  imports: [AsyncPipe, CpCheckboxComponent, ReactiveFormsModule, ButtonDirective, IconComponent, ActivityLogClickDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsAndConditionsAgreementComponent {
  private readonly globalStore = inject(Store);
  private readonly authService = inject(AuthService);

  readonly company$: Observable<HTTP_CP_Company> = this.globalStore.select(selectCompany);

  readonly privacyPolicyLink = 'https://www.dashly.com/terms/privacy';
  readonly tacLink = 'https://www.dashly.com/terms';
  acceptedTermsAndConditionsForm = new FormGroup({
    agreeTerms: new FormControl(null, [Validators.requiredTrue]),
  });

  protected readonly addClassAndTargetToInnerHtmlConsentText = addClassAndTargetToInnerHtmlConsentText;
  protected readonly AnalyticClickEventNames = ANALYTIC_CLICK_EVENT_NAMES;

  logout(): void {
    this.authService.logoutAndRedirect();
  }

  agreeAndLogin(): void {
    if (this.acceptedTermsAndConditionsForm.invalid) {
      return;
    }
    this.globalStore.dispatch(agreeToTermsAndConditions());
  }

  showWarnState(): boolean {
    const control = this.acceptedTermsAndConditionsForm.controls.agreeTerms;
    return control.touched && control.invalid;
  }
}
